<template>
    <a href="#" title="Transmettre ce point" @click="sendItem()">
        <i class="fas fa-fw fa-share-square text-secondary"></i>
    </a>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../../dashboard/mixins/DataUpdater'

export default {
    name: 'SendPendingPoint',

    mixins: [DataUpdater],

    props: {
        point: {},
    },

    methods: {
        async sendItem() {
            const form = {}
            form.status = 'SEN'
            try {
                await axios.put(`/pendingPoints/${this.point.id}/status`, form)
                this.filterData(this.point.id)
            } catch (error) {
                console.log(error)
            }
        },
    },

    computed: {
        ...mapState({
            pageName: (state) => state.browsing.pageName,
        }),
    },
}
</script>

<style scoped></style>
